import React from 'react';
import { useMediaQuery } from "@mui/material";
import Desktop from "@navbar/desktop.navbar";
import Mobile from "@navbar/mobile.navbar";

const NavigationBar = () => {
    const isDesktop = useMediaQuery("(min-width:992px)");


    const renderDesktop = () => (
        <>
            <Desktop />
        </>
    );

    const renderMobile = () => (
        <>
            <Mobile />
        </>
    );

    return <>{isDesktop ? renderDesktop() : renderMobile()}</>;
};

export default NavigationBar;
